module.exports = __webpack_public_path__ + "e274a23e362234e96f8fa2898b0d944c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-default.png
// module id = 225
// module chunks = 0